import './input.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './app'
import { captureSignupAttribution } from './signup-attribution'

//	runs on every page load (landing, /chat, direct links, etc.) so a campaign link can point
//	anywhere and still be captured before the user eventually reaches signup.
captureSignupAttribution()

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/sw.js')
			.then((registration) => {
				console.log('[PWA] Service Worker registered successfully:', registration.scope)
			})
			.catch((error) => {
				console.error('[PWA] Service Worker registration failed:', error)
			})
	})

	// Handle messages from service worker
	navigator.serviceWorker.addEventListener('message', (event) => {
		if (event.data?.type === 'GET_CURRENT_PATH') {
			event.ports[0].postMessage({ pathname: window.location.pathname })
		} else if (event.data?.type === 'NAVIGATE_TO') {
			window.location.href = event.data.url
		}
	})
}

//	the root holds prerendered markup when the page came from the build-time prerender
//	(scripts/prerender.mjs). it is only ours to hydrate when it was rendered for this path:
//	Cloudflare Pages also serves the prerendered index.html as the SPA fallback for /chat,
//	/settings etc., and there the markup is the landing page, hidden by an inline script
//	in the head until we replace it here.
const rootElement = document.getElementById('root') as HTMLElement
const app = (
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
)

if (prerenderedPathMatches(rootElement.dataset.prerenderedPath))
	ReactDOM.hydrateRoot(rootElement, app)
else {
	rootElement.replaceChildren()
	document.documentElement.removeAttribute('data-prerender-stale')
	ReactDOM.createRoot(rootElement).render(app)
}

//	keep the path normalization identical to the inline script written by scripts/prerender.mjs
function prerenderedPathMatches(prerenderedPath: string | undefined) {
	if (!prerenderedPath) return false
	return (window.location.pathname.replace(/\/+$/, '') || '/') === prerenderedPath
}
